import type { SchemaManualOffer } from 'cpool-schemas';
import { schemaManualOffer } from 'cpool-schemas';
import { z } from 'zod';

export const schemaManualOfferForm = schemaManualOffer
    .omit({
        acceptanceStatus: true,
        acceptedAt: true,
        commissionResponseInPercent: true,
        file: true,
        id: true,
    })
    .extend({
        commissionAmount: z.coerce.number().optional(),
        commissionResponseInPercent: z.coerce.number().optional(),
        file: z.instanceof(File).optional(),
    });

export type SchemaManualOfferForm = Omit<
    SchemaManualOffer,
    'id' | 'file' | 'acceptanceStatus' | 'acceptedAt' | 'provision'
> & {
    file: File;
    commissionAmount?: number;
};
